import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';
import { Observable } from 'rxjs';


export const photoWidth = 90;
export const photoWidthPx = `${photoWidth}px`;
export const brandWidth = 115;
export const brandWidthPx = `${brandWidth}px`;
export const partNumberWidth = 105;
export const partNumberWidthPx = `${partNumberWidth}px`;
export const quantityWidth = 99;
export const quantityWidthPx = `${quantityWidth}px`;
export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;
// eslint-disable-next-line max-len
export const descriptionWidth = `calc(100% - ${photoWidthPx} - ${brandWidthPx} - ${partNumberWidthPx} - ${quantityWidthPx} - ${collapseWidthPx})`;
export const soldSeparatelyWidth = '25%';

export const rowData: Array<any> = [
  {
    fieldName: 'componentBrandLabel',
    width: `${brandWidthPx}`,
    disabled: true,
  }, {
    fieldName: 'componentPartNumber',
    width: `${partNumberWidthPx}`,
    fontRegular: true,
    typeahead: true,
  }, {
    fieldName: 'quantityInKit',
    width: `${quantityWidthPx}`,
    combined: ['quantityInKit', 'quantityInKitUom'],
    fontRegular: true,
    numerical: true,
    allow_decimal: false,
  }, {
    fieldName: 'description',
    combined: ['description', 'descriptionType'],
    width: descriptionWidth,
    fontRegular: true,
  },
];

export const contentData: Array<any> = [[
  {
    fieldName: 'partType',
    width: '100%',
    disabled: true,
  }], [{
    fieldName: 'descriptionLanguage',
    width: `${photoWidth + brandWidth}px`,
    type: DetailsControlType.Select,
  }, {
    fieldName: 'componentSubBrandLabel',
    disabled: true,
    width: `${partNumberWidth + quantityWidth}px`,
  }, {
    fieldName: 'componentIdQualifier',
    textMask: 'cc',
    type: DetailsControlType.Select,
    width: `calc(100% - ${photoWidthPx} - ${brandWidthPx} - ${partNumberWidthPx} - ${quantityWidthPx} - ${soldSeparatelyWidth})`,
  }, {
    fieldName: 'soldSeparately',
    type: DetailsControlType.Select,
    width: soldSeparatelyWidth,
  }],
];
